import React from "react";

import TeamRoleSelect from "../../../team/components/TeamRoleSelect/TeamRoleSelect";

export default function OfferRoleSelect(props) {
	return <TeamRoleSelect {...props} />;
}
